import { c as _c } from "react/compiler-runtime";
import { Image } from '@/components/client';
export const StaticBanner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="flex flex-col">{TOP_BANNER_IMAGE_URLS.map(_temp)}</section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
interface ImageSectionProps {
  imageUrl: string;
  width: number;
  height: number;
  alt: string;
  title: string;
  description: string;
}
const ImageSection = t0 => {
  const $ = _c(13);
  const {
    imageUrl,
    width,
    height,
    alt,
    title,
    description
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="sr-only">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = <p className="sr-only">{description}</p>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== alt || $[5] !== height || $[6] !== imageUrl || $[7] !== width) {
    t3 = <Image src={imageUrl} width={width} height={height} className="w-full" alt={alt} />;
    $[4] = alt;
    $[5] = height;
    $[6] = imageUrl;
    $[7] = width;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <section className="flex flex-col">{t1}{t2}{t3}</section>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
const TOP_BANNER_IMAGE_URLS = [{
  url: 'https://cdn.welfarehello.com/static/donation-gift-detail-notes.png',
  width: 1_125,
  height: 2_859,
  alt: '고향사랑기부 혜택 정보를 가르쳐주는 이미지',
  title: '10만원 기부하면, 전액 세액공제 받고, 3만원 답례품을 받아요',
  description: '소중한 기부금, 이렇게 사용돼요. 1.기부금은 해당 지자체로 바로 전달되어 주민 복리 증진 사업에 사용돼요. 2. 각 지자체는 기부금 사용내역을 매년 2월 지자체 홈페이지에 투명하게 공개해요. 3. 고향사랑기부금법에 따라 지원금은 사회적 취약계층 지원과 청소년 육성 보호, 지역 주민 문화 예술 보건 증진, 지역 공동체 활성화 지원, 주민 복리증진 사업 등 정해진 용도로만 사용 가능해요. 참고하세요! 올해 이미 전액 환급 대상인 경우 올해는 고향사랑기부금 세액공제가 적용되지 않습니다. 다만, 해당 공제액은 사라지지 않고 최대 10년 동안 이월하여 공제 받을 수 있습니다.'
}];
function _temp(image) {
  return <ImageSection key={image.url} imageUrl={image.url} width={image.width} height={image.height} alt={image.alt} title={image.title} description={image.description} />;
}